



































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  Ref,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getQuiz,
  createQuiz,
  updateQuiz,
} from '@/api';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const PanelWithQuizEditor = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  props: {
    edit: {
      default() { return false; },
    },
  },
  setup(props: any) {
    const { route } = useRouter();
    const NOW = new Date();

    const successModal = ref(null);
    const loading = ref(true);

    const deletedChoices: Ref<number[]> = ref([]);
    const runningOrder = ref(0);

    const form = reactive({
      name: '',
      question: '',
      activeForSeconds: 60 * 5,
      quizChoices: [
        /* eslint-disable */
        { text: '', correct: false, order: 1 },
        { text: '', correct: false, order: 2 },
      ] as { id?: number, text: string, correct: boolean, order: number }[],
      call: async () => {
        // let result = '';
        // const date = (new Date(``));
        if (props.edit === true) {
          await updateQuiz(route.value.params.quizId, {
            name: form.name,
            active_for_seconds: form.activeForSeconds,
            text: form.question,
            quiz_choices: form.quizChoices.map((choice) => ({ ...choice, order: runningOrder.value += 1 })),
            deleteChoices: deletedChoices.value,
          });
        }
        else {
          await createQuiz(route.value.params.liveId, {
            name: form.name,
            active_for_seconds: form.activeForSeconds,
            text: form.question,
            quiz_choices: form.quizChoices,
          });
        }
        /* eslint-enable */
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
      },
      state: {
        value: 'READY',
      },
    });

    onMounted(async () => {
      if (props.edit === true) {
        const result = await getQuiz(route.value.params.quizId);
        form.name = result.name;
        form.activeForSeconds = result.active_for_seconds;
        form.question = result.text;
        form.quizChoices = result.choices.map((choice: any) => ({
          id: choice.id,
          text: choice.text,
          order: choice.order,
          // eslint-disable-next-line
          correct: choice.correct,
        })).sort((a: any, b: any) => a.order - b.order);
      }
      loading.value = false;
    });

    function deleteChoiceHandler(index: number) {
      if (form.quizChoices[index].id && form.quizChoices[index].id !== -1 && props.edit) {
        deletedChoices.value.push(form.quizChoices[index].id as number);
      }
      form.quizChoices.splice(index, 1);
    }

    return {
      form,

      successModal,

      deleteChoiceHandler,
    };
  },
});

export default PanelWithQuizEditor;
